const views = (base, n) => Array.from({ length: n }, (_, i) => `/products/${base}-${i + 1}.png`);

// Coming-Soon-Sperrbildschirm: auf "false" setzen, um die komplette Seite freizuschalten
export const COMING_SOON = true;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1676655079738-af54dfd6318e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxib3hlciUyMHRyYWluaW5nJTIwZGFyayUyMGd5bSUyMHNwb3RsaWdodHxlbnwwfHx8fDE3OTA2MTM1NjF8MA&ixlib=rb-4.1.0&q=85",
  ring: "https://images.unsplash.com/photo-1546711076-85a7923432ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHszfHxib3hpbmclMjBnbG92ZXMlMjBmaWdodGVyJTIwdHJhaW5pbmd8ZW58MHx8fHwxNzkwNjEyNzc5fDA&ixlib=rb-4.1.0&q=85",
};

export const PRODUCTS = [
  {
    id: "apex-pro-obsidian",
    lookup_key: "apex_pro_obsidian",
    name: "APEX PRO 16 OZ",
    variant: "Obsidian Gold",
    cat: "Dark",
    tag: "Fight Grade",
    price_eur: 129.9,
    desc: "Schwarzes Fight-Grade Leder mit goldenen Cut-Linien, dreilagigem Schaumkern und 360° Wrist Lock.",
    imgs: views("apex-pro-obsidian", 8),
  },
  {
    id: "apex-pro-bianco",
    lookup_key: "apex_pro_bianco",
    name: "APEX PRO 16 OZ",
    variant: "Bianco Gold",
    cat: "White",
    tag: "Fight Grade",
    price_eur: 129.9,
    desc: "Weißes Fight-Grade Leder mit goldenen Details — derselbe Schutz, dieselbe Präzision, heller Auftritt.",
    imgs: views("apex-pro-bianco", 8),
  },
  {
    id: "sentinel-schwarz",
    lookup_key: "sentinel_schwarz",
    name: "SENTINEL BANDAGEN",
    variant: "Schwarz/Gold",
    cat: "Dark",
    tag: "4,5 m Halbspanne",
    price_eur: 19.9,
    desc: "Halbspannen-Bandagen mit Klettverschluss und Mazaro-Siegel — fester Halt, Runde für Runde.",
    imgs: views("sentinel-schwarz", 7),
  },
  {
    id: "sentinel-weiss",
    lookup_key: "sentinel_weiss",
    name: "SENTINEL BANDAGEN",
    variant: "Weiß/Gold",
    cat: "White",
    tag: "4,5 m Halbspanne",
    price_eur: 19.9,
    desc: "Halbspannen-Bandagen in Weiß/Gold — atmungsaktiv, maschinenwaschbar, mit goldenem Mazaro-Siegel.",
    imgs: views("sentinel-weiss", 7),
  },
];

export const GLOVE_SPECS = {
  "12oz": {
    oz: "12",
    use: "Pad- & Sackarbeit",
    padding: "Kompakt",
    speed: "Maximal",
    note: "Für Speed und saubere Technik — dein Begleiter für jede Bag-Session.",
  },
  "14oz": {
    oz: "14",
    use: "Technik- & leichtes Sparring",
    padding: "Ausgewogen",
    speed: "Hoch",
    note: "Der Allrounder im Gym: schnell genug für Pads, weich genug für Technik.",
  },
  "16oz": {
    oz: "16",
    use: "Sparring & Fight",
    padding: "Maximal",
    speed: "Solide",
    note: "Volle Dämpfung und maximaler Schutz — gebaut für harte Runden.",
  },
};

export const CHAPTERS = [
  {
    nr: "Kapitel 01",
    title: "Der Gym",
    text: "Alles beginnt im Keller: Schweiß, Leinentuch und der Wille, besser zu werden als gestern.",
  },
  {
    nr: "Kapitel 02",
    title: "Das Handwerk",
    text: "Jedes Produkt entsteht aus dem Training heraus — getestet an der Tasche, nicht am Schreibtisch.",
  },
  {
    nr: "Kapitel 03",
    title: "Die Weltbühne",
    text: "Vom ersten Sparring bis zum Titelkampf: Ausrüstung, die mitgeht, wohin auch immer der Ring steht.",
  },
];

export const ATHLETES = [
  {
    quote: "Die Handschuhe sitzen wie eine zweite Haut. Kein Einlaufen, keine Kompromisse.",
    name: "Kaan Y.",
    role: "Supermittelgewicht",
    initial: "K",
  },
  {
    quote: "Endlich eine Marke, die Boxen ernst nimmt — vom Cut bis zur letzten Naht.",
    name: "Lena O.",
    role: "Amateur-Boxen",
    initial: "L",
  },
  {
    quote: "Der Wrist Lock gibt mir jede Schlagkraft zurück, die ich brauche. Runde für Runde.",
    name: "Marco R.",
    role: "Profi-Fighter",
    initial: "M",
  },
];
